/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetDepartmentAndWorkAreaTreeParams,
  GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest,
  GetSimpleWorkAreasByIdsParams,
  GetWorkAreaTreeParams,
  GetWorkareaModuleParams,
  PermissionTypeTreeInfo,
  SimpleWorkArea,
  TsModule,
  UserPermissionTreeInfo
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsUrl = () => {




  return `/api/WorkArea/GetDepartmentAndWorkAreaTreeWithDutyRosterPermissions`
}

export const getDepartmentAndWorkAreaTreeWithDutyRosterPermissions = async (getDepartmentWorkareaTreeWithDutyRosterPermissionsRequest?: GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest, options?: Parameters<typeof customInstance>[1]): Promise<PermissionTypeTreeInfo> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<PermissionTypeTreeInfo>(getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(getDepartmentWorkareaTreeWithDutyRosterPermissionsRequest)
  }
);}





export const getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationKey = () => ['getDepartmentAndWorkAreaTreeWithDutyRosterPermissions'] as const;

export const getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>, TError,GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>, TError,GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationVariables, TContext> => {

const mutationKey = getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>, GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getDepartmentAndWorkAreaTreeWithDutyRosterPermissions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationResult = NonNullable<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>>
    export type GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationBody = BodyType<GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest> | undefined
    export type GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationError = ErrorType<unknown>
    export type GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationVariables = {data?: BodyType<GetDepartmentWorkareaTreeWithDutyRosterPermissionsRequest>}

    export const useGetDepartmentAndWorkAreaTreeWithDutyRosterPermissions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>, TError,GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getDepartmentAndWorkAreaTreeWithDutyRosterPermissions>>,
        TError,
        GetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationVariables,
        TContext
      > => {
      return useMutation(getGetDepartmentAndWorkAreaTreeWithDutyRosterPermissionsMutationOptions(options), queryClient);
    }
    export const getGetDepartmentAndWorkAreaTreeUrl = (params: GetDepartmentAndWorkAreaTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["whereModule"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkArea/GetDepartmentAndWorkAreaTree?${stringifiedParams}` : `/api/WorkArea/GetDepartmentAndWorkAreaTree`
}

export const getDepartmentAndWorkAreaTree = async (params: GetDepartmentAndWorkAreaTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<UserPermissionTreeInfo> => {

  return customInstance<UserPermissionTreeInfo>(getGetDepartmentAndWorkAreaTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDepartmentAndWorkAreaTreeQueryKey = (params?: GetDepartmentAndWorkAreaTreeParams,) => {
    return [
    `/api/WorkArea/GetDepartmentAndWorkAreaTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDepartmentAndWorkAreaTreeQueryOptions = <TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentAndWorkAreaTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>> = ({ signal }) => getDepartmentAndWorkAreaTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDepartmentAndWorkAreaTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>>
export type GetDepartmentAndWorkAreaTreeQueryError = ErrorType<unknown>


export function useGetDepartmentAndWorkAreaTree<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentAndWorkAreaTree<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>,
          TError,
          Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentAndWorkAreaTree<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDepartmentAndWorkAreaTree<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentAndWorkAreaTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDepartmentAndWorkAreaTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDepartmentAndWorkAreaTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>> = ({ signal }) => getDepartmentAndWorkAreaTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDepartmentAndWorkAreaTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>>
export type GetDepartmentAndWorkAreaTreeSuspenseQueryError = ErrorType<unknown>


export function useGetDepartmentAndWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentAndWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDepartmentAndWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDepartmentAndWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: GetDepartmentAndWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDepartmentAndWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDepartmentAndWorkAreaTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWorkareaModuleUrl = (params?: GetWorkareaModuleParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkArea/GetWorkareaModule?${stringifiedParams}` : `/api/WorkArea/GetWorkareaModule`
}

export const getWorkareaModule = async (params?: GetWorkareaModuleParams, options?: Parameters<typeof customInstance>[1]): Promise<TsModule> => {

  return customInstance<TsModule>(getGetWorkareaModuleUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkareaModuleQueryKey = (params?: GetWorkareaModuleParams,) => {
    return [
    `/api/WorkArea/GetWorkareaModule`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkareaModuleQueryOptions = <TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(params?: GetWorkareaModuleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkareaModuleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkareaModule>>> = ({ signal }) => getWorkareaModule(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkareaModuleQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkareaModule>>>
export type GetWorkareaModuleQueryError = ErrorType<unknown>


export function useGetWorkareaModule<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params: undefined |  GetWorkareaModuleParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkareaModule>>,
          TError,
          Awaited<ReturnType<typeof getWorkareaModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkareaModule<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkareaModule>>,
          TError,
          Awaited<ReturnType<typeof getWorkareaModule>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkareaModule<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkareaModule<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkareaModuleQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWorkareaModuleSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(params?: GetWorkareaModuleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkareaModuleQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkareaModule>>> = ({ signal }) => getWorkareaModule(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWorkareaModuleSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkareaModule>>>
export type GetWorkareaModuleSuspenseQueryError = ErrorType<unknown>


export function useGetWorkareaModuleSuspense<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params: undefined |  GetWorkareaModuleParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkareaModuleSuspense<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkareaModuleSuspense<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkareaModuleSuspense<TData = Awaited<ReturnType<typeof getWorkareaModule>>, TError = ErrorType<unknown>>(
 params?: GetWorkareaModuleParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkareaModule>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkareaModuleSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleWorkAreasByIdsUrl = (params: GetSimpleWorkAreasByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["workAreaIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkArea/GetSimpleWorkAreasByIds?${stringifiedParams}` : `/api/WorkArea/GetSimpleWorkAreasByIds`
}

export const getSimpleWorkAreasByIds = async (params: GetSimpleWorkAreasByIdsParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleWorkArea[]> => {

  return customInstance<SimpleWorkArea[]>(getGetSimpleWorkAreasByIdsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimpleWorkAreasByIdsQueryKey = (params?: GetSimpleWorkAreasByIdsParams,) => {
    return [
    `/api/WorkArea/GetSimpleWorkAreasByIds`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimpleWorkAreasByIdsQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleWorkAreasByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>> = ({ signal }) => getSimpleWorkAreasByIds(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimpleWorkAreasByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>>
export type GetSimpleWorkAreasByIdsQueryError = ErrorType<unknown>


export function useGetSimpleWorkAreasByIds<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleWorkAreasByIds<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleWorkAreasByIds<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleWorkAreasByIds<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleWorkAreasByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimpleWorkAreasByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimpleWorkAreasByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>> = ({ signal }) => getSimpleWorkAreasByIds(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimpleWorkAreasByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>>
export type GetSimpleWorkAreasByIdsSuspenseQueryError = ErrorType<unknown>


export function useGetSimpleWorkAreasByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleWorkAreasByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimpleWorkAreasByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimpleWorkAreasByIdsSuspense<TData = Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError = ErrorType<unknown>>(
 params: GetSimpleWorkAreasByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimpleWorkAreasByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimpleWorkAreasByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWorkAreaTreeUrl = (params?: GetWorkAreaTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/WorkArea/GetWorkAreaTree?${stringifiedParams}` : `/api/WorkArea/GetWorkAreaTree`
}

export const getWorkAreaTree = async (params?: GetWorkAreaTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetWorkAreaTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetWorkAreaTreeQueryKey = (params?: GetWorkAreaTreeParams,) => {
    return [
    `/api/WorkArea/GetWorkAreaTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetWorkAreaTreeQueryOptions = <TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(params?: GetWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkAreaTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkAreaTree>>> = ({ signal }) => getWorkAreaTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWorkAreaTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkAreaTree>>>
export type GetWorkAreaTreeQueryError = ErrorType<unknown>


export function useGetWorkAreaTree<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetWorkAreaTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkAreaTree>>,
          TError,
          Awaited<ReturnType<typeof getWorkAreaTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkAreaTree<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
 params?: GetWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWorkAreaTree>>,
          TError,
          Awaited<ReturnType<typeof getWorkAreaTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkAreaTree<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
 params?: GetWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkAreaTree<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
 params?: GetWorkAreaTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkAreaTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetWorkAreaTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(params?: GetWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWorkAreaTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkAreaTree>>> = ({ signal }) => getWorkAreaTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetWorkAreaTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkAreaTree>>>
export type GetWorkAreaTreeSuspenseQueryError = ErrorType<unknown>


export function useGetWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetWorkAreaTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
 params?: GetWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
 params?: GetWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetWorkAreaTreeSuspense<TData = Awaited<ReturnType<typeof getWorkAreaTree>>, TError = ErrorType<unknown>>(
 params?: GetWorkAreaTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getWorkAreaTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWorkAreaTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






